<template>
  <Modal
    framed
    as-form
    open
    persistent
    :size="ModalSize.LG"
    :title="$t('accept-terms-modal.title')"
    :cancel-label="$t('accept-terms-modal.decline')"
    :confirm-label="$t('accept-terms-modal.accept')"
    @cancel="navigateTo('/')"
  >
    <template #body="{ formId, close }">
      <form :id="formId" method="post" @submit.prevent="onAcceptTerms(close)">
        <p class="font-semibold text-on-surface text-center">
          <i18n-t keypath="accept-terms-modal.description">
            <template #title> {{ props.hub.title }} </template>
          </i18n-t>
        </p>
        <div
          class="bg-disabled p-8 flex items-center justify-between flex-wrap mt-6 rounded-lg"
          :class="{ 'border border-error': showTermsNotViewedError }"
        >
          <span class="font-semibold max-w-100 text-on-surface text-lg">
            {{ props.hub.termsDescription }}
          </span>
          <Button
            label="View"
            :variant="ButtonVariant.OUTLINED"
            :to="props.hub.termsUrl"
            target="_blank"
            @click="onViewTerms"
          />
        </div>
        <p
          class="text-on-surface text-sm text-center mt-3"
          :class="{ 'text-error': showTermsNotViewedError }"
        >
          {{ $t('accept-terms-modal.requirement') }}
        </p>
      </form>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { Button, ButtonVariant, ModalSize, Modal } from '@exfluential/ui';
import { ref } from '#imports';
import { useAcceptedHubsTerms } from '~/pages/_components/hub-details/_composables/use-accepted-hubs-terms';

type Props = {
  hub: Record<string, unknown>;
};
const props = defineProps<Props>();
const { acceptHubTerms } = useAcceptedHubsTerms();

const termsViewed = ref<boolean>(false);
const showTermsNotViewedError = ref<boolean>(false);

const onViewTerms = () => {
  termsViewed.value = true;
  showTermsNotViewedError.value = false;
};

const onAcceptTerms = (closeModal: () => void) => {
  if (!termsViewed.value) {
    showTermsNotViewedError.value = true;
    return;
  }
  acceptHubTerms(props.hub.id);

  closeModal();
};
</script>
